import axios from 'axios'; 
import { redirectBasedOnRole } from '../../routes/decodedAdmin';

const apiClient = axios.create();

// Set token and tenant so backend can filter by tenant (e.g. GetKnowledgeBasesForTenant)
apiClient.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  const tenantId = localStorage.getItem('tenant_id');
  if (tenantId) config.headers['X-Tenant-Id'] = tenantId;
  return config;
});

// ✅ Response interceptor
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error.response?.status;
    const token = localStorage.getItem('token');

    // Only handle authentication errors
    if (status === 401) {
      // Token might be expired or invalid
      localStorage.removeItem('token');
      window.location.href = '/login';  // ⛔ User is not authenticated
    } else if (status === 403) {
      // User is authenticated but doesn't have access
      console.warn('You do not have permission to perform this action.');
      // Optionally show a 403 error page or a toast notification
      // window.location.href = '/forbidden'; 
    }

    // All other errors should be handled where the request was made
    return Promise.reject(error);
  }
);


export default apiClient;
